









































import Component, {mixins} from 'vue-class-component';
import BButton from 'buefy/src/components/button/Button.vue';
import {MAFUser} from '@/store/User/types';
import {namespace, State} from 'vuex-class';
import BTimepicker from 'buefy/src/components/timepicker/Timepicker.vue';
import BDatepicker from 'buefy/src/components/datepicker/Datepicker.vue';
import BClockpicker from 'buefy/src/components/clockpicker/Clockpicker.vue';
import BField from 'buefy/src/components/field/Field.vue';
import BLoading from 'buefy/src/components/loading/Loading.vue';
import {Emit, Vue} from 'vue-property-decorator';
import {meetup, Meetup} from '@/store/Friends/types';
import {DateTime} from 'luxon';
import {AddressComponent, PlaceDetailsResult} from '@google/maps';
import * as _ from 'lodash';

// TODO: fix this file so these rules don't need to be disabled
/* tslint:disable:no-empty */

const friendPath = 'friendState';
const friendNamespace = namespace(friendPath);

const userPath = 'userState';
const userNamespace = namespace(userPath);

@Component({
    components: {
        BField,
        BClockpicker,
        BDatepicker,
        BTimepicker,
        BButton,
        BLoading,
    },
})
export default class CurrentMeetUpModal extends Vue {
    @userNamespace.State('self') public readonly self!: MAFUser;
    @friendNamespace.State('meetups') public readonly meetups!: Meetup[];
    @friendNamespace.Action('updateMeetup') public updateMeetup!: any;
    @friendNamespace.Action('sendEmailNotification') public sendEmailNotification!: any;
    public BASE_URL: string = process.env.BASE_URL ? process.env.BASE_URL : '';

    constructor() {
        super();
    }

    public formatDate(date: Date) {
        return DateTime.fromJSDate(date).toFormat('cccc, LLLL d / t');
    }

    public selectedCity(res: PlaceDetailsResult): string {
        let city = '';
        let state = '';
        for (const comp of res.address_components) {
            if (comp.types.includes('locality')) {
                city = comp.long_name;
            }
            if (comp.types.includes('administrative_area_level_1')) {
                state = comp.long_name;
            }
        }

        return `${city}, ${state}`;
    }
    get confirmedNonChangeable() {
        return _.filter(this.meetups, (mu: Meetup) => {
            return mu.confirmed && this.self.uid && !mu.canICancel(this.self.uid) && !mu.canceled;
        });
    }

    get pendingAndCancelable() {
        return _.filter(this.meetups, (mu: Meetup) => {
            let ret = (
                !mu.confirmed &&
                this.self.uid &&
                mu.canIConfirm(this.self.uid)) || ( this.self.uid && (mu.canICancel(this.self.uid) )
            );
            if (ret && mu.canceled) {
                ret = false;
            }
            return  ret;
        });
    }
    public async confirmOrCancel(mu: Meetup, confirm: boolean) {
        const emailMessage: string = '';
        let to: any = [];

        if ( confirm ) {
            // someone else has sent you an invite, let them know you're accepting
            mu.confirmed = true;
            to = mu.Inviter;
        } else {
            // you sent the invite, let them know you're canceling
            mu.canceled = true;
            to = mu.Invitee;
        }
        /* tslint:disable:max-line-length */
        await this.updateMeetup({mu, mid: mu.id, uid: this.self.uid} );
        this.sendEmailNotification(
            {
                to: to.email,
                mess: `Hello, ${to.name}! ${this.self.name} has ${(confirm) ? 'confirmed your meetup invite. Please remember to be safe when meeting with someone you don\'t know, and have fun!' : 'is canceling their meetup invite. This can sometimes happen when their plans have changed.'}`,
            },
        );
    }

    @Emit('close')
    public close() {
    }

}
